import { render, staticRenderFns } from "./CardChatbot.vue?vue&type=template&id=2bf31ab6&scoped=true&"
import script from "./CardChatbot.vue?vue&type=script&lang=js&"
export * from "./CardChatbot.vue?vue&type=script&lang=js&"
import style0 from "./CardChatbot.vue?vue&type=style&index=0&id=2bf31ab6&prod&lang=sass&scoped=true&"
import style1 from "./CardChatbot.vue?vue&type=style&index=1&id=2bf31ab6&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf31ab6",
  null
  
)

export default component.exports